module.exports = __webpack_public_path__ + "img/no_order.f27af9bb.svg";